import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

export const useOrder = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("usePaymethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const order = sharedRef(null, `useOrder-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOrder-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOrder-error-${orderId}`);

  // 查询订单
  const load = async (orderID: any) => {
    try {
      loading.value = true;
      const orderIds = orderID || orderId;
      const res = await context.$xbuy.api.orderQuery(orderIds);
      // console.log('api.orderQuery---------', orderId, res);

      // context.useApiError.set(res);
      if (res && res.code === 0) {
        order.value = res.data;
        error.value = null;
      } else {
        error.value = res.message;
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    load,
    isPayed: computed(() => order.value && order.value.status === 'COMPLETED'),
    order: computed(() => order.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
